<template>
  <Customer />
</template>

<script>
import Customer from '../components/Customer';

export default {
  name: 'CustomerInformation',
  components: {
    Customer,
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    this.$store.dispatch('AICustomers/fetchCustomer', this.$route.params.id);
  },
};
</script>

<style scoped>

</style>
